<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="productionrecordPopup()">新增生产记录</el-button>
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="recordCode" label="生产记录号">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.recordCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="产品名称"></el-table-column>
      <el-table-column prop="productionDate" label="生产开始日期">
        <template slot-scope="scope">{{ scope.row.startDate | formatDate }}</template>
      </el-table-column>
      <el-table-column prop="endDate" label="生产结束日期">
        <template slot-scope="scope">{{ scope.row.endDate | formatDate }}</template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="text" @click="productionrecordPopup(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="productionrecordDel(scope.row.id)">删除</el-button>
          <el-button type="text" @click="openBatch(scope.row.id, scope.row.productId)">批次信息</el-button>
          <el-button
            type="text"
            @click="openMaterialuseinfo(scope.row.id, scope.row.productId)"
          >用料填报</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    ></pagination>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="productionrecordFormVisible"
      center
      width="50%"
    >
      <AddForm
        ref="productionrecordForm"
        @productionrecordFinish="productionrecordFinish"
        @closePopup="closePopup"
      />
    </el-dialog>
    <!-- 批次信息 -->
    <Dialog title="批次信息" :visible.sync="drawer" :with-header="false" center width="85%">
      <div class="content-detail">
        <Batch ref="batchInfo" :productionRecordId="productionRecordId" :productId="productId" />
      </div>
    </Dialog>
    <!-- 用料填报 -->
    <Dialog title="用料填报" :visible.sync="drawerUseInfo" :with-header="false" center width="85%">
      <div class="content-detail">
        <Materialuseinfo ref="useInfo" :productionRecordId="productionRecordId" :productId="productId" />
      </div>
    </Dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawerDetail" size="50%" :with-header="false">
      <div class="content-detail">
        <h2>
          <span>生产记录详细信息</span>
          <i class="el-icon-circle-close" @click="drawerDetail = false" style="position: absolute; top: 20px; right: 20px; cursor: pointer; font-size: 20px;"></i>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">生产记录号</td>
            <td>{{ detailDate.recordCode }}</td>
            <td class="list-item">产品名称</td>
            <td>{{ detailDate.productName }}</td>
          </tr>
          <tr>
            <td class="list-item">产品分类</td>
            <td>{{ detailDate.categoryName }}</td>
            <td class="list-item">产品类别</td>
            <td>{{ detailDate.productType | productTypeName }}</td>
          </tr>
          <tr>
            <td class="list-item">生产开始日期</td>
            <td>{{ detailDate.startDate | formatDate }}</td>
            <td class="list-item">生产结束时间</td>
            <td>{{ detailDate.endDate | formatDate }}</td>
          </tr>
          <tr>
            <td class="list-item">生产排班</td>
            <td>
              <p v-for="(item, index) in detailDate.orderClasses" :key="item.id">{{index+1}}.排班名称：{{item.name}}<br>排班地址：{{item.address}}</p>
            </td>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import AddForm from './components/AddForm'
import Batch from './components/Batch'
import Materialuseinfo from './components/Materialuseinfo'
import {
  getProductionrecordList,
  delProductionrecordList,
  getProductionrecordDetail,
  deleteProductionrecordDel
} from '@/api/productionrecord'

export default {
  components: {
    AddForm,
    Batch,
    Materialuseinfo
  },
  data() {
    return {
      productionrecordFormVisible: false,
      drawer: false,
      drawerUseInfo: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      detailDate: {},
      drawerDetail: false,
      currentID: null,
      productId: null,
      productionRecordId: null,
      selectionID: [],
      loading: true,
      tableData: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑生产记录' : '新增生产记录'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delProductionrecordList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getProductionrecordListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getProductionrecordListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getProductionrecordListData()
    },
    // 删除生产记录
    productionrecordDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteProductionrecordDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除生产记录成功')
              this.getProductionrecordListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 打开批次信息
    openBatch(id, productId) {
      this.drawer = true
      this.productId = productId
      this.productionRecordId = id
    },
    // 打开用料填报
    openMaterialuseinfo(id, productId) {
      this.drawerUseInfo = true
      this.productId = productId
    },
    // 打开表单层
    productionrecordPopup(id) {
      const isAdd = !id
      this.productionrecordFormVisible = true
      if (isAdd) {
        this.currentID = null
        this.$nextTick(() => {
          this.$refs.productionrecordForm.productionrecordFormPopup()
        })
      } else {
        this.currentID = id
        this.$nextTick(() => {
          this.$refs.productionrecordForm.productionrecordFormPopup(id)
        })
      }
    },
    closePopup() {
      this.productionrecordFormVisible = false
    },
    productionrecordFinish() {
      this.productionrecordFormVisible = false
      this.getProductionrecordListData()
    },
    // 检索
    search() {
      this.getProductionrecordListData()
    },
    // 刷新数据表格
    refresh() {
      this.getProductionrecordListData()
      this.$message.success('数据刷新成功')
    },
    // 详情
    detailShow(id) {
      this.drawerDetail = true
      getProductionrecordDetail(id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取生产记录列表
    getProductionrecordListData() {
      this.loading = true
      getProductionrecordList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getProductionrecordListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    // 产品类别：1:初级农产品、0:加工品
    productTypeName(value) {
      const map = { 1: '初级农产品', 0: '加工品' }
      return map[value] !== undefined ? map[value] : value
    }
  }
}
</script>
